import {
  put, takeEvery, all, select, call, fork, takeLatest,
} from 'redux-saga/effects';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { exception } from 'circe/logger';
import moment from 'moment';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import * as listingSaga from 'circe/listing/saga';
import { getCurrency } from 'domain/fuse/preferences/currency';
import * as api from './api';
import {
  cache,
  fetch,
  fetched,
  fetching,
  fetchNext,
  fetchPrev,
  markAsPaid,
  markedAsPaid,
} from './actions';
import {
  getFilters,
  getHasNext,
  getHasPrev,
  getNextCursor,
  getPrevCursor,
  getFromCache,
} from './selectors';

function* doFetch({ payload }) {
  try {
    const { filters } = payload;

    const state = yield select();
    const DEFAULT_CURRENCY = yield call(getCurrency, state);

    const sdate = filters.sdate ? moment(filters.sdate) : moment().subtract(30, 'days');
    const edate = filters.sdate ? moment(filters.edate) : moment();

    yield fork(listingSaga.doFetch, {
      api: api.fetch,
      filters: {
        ...filters,
        sdate: sdate.valueOf(),
        edate: edate.valueOf(),
      },
      fetched,
      cache,
      getFromCache,
      getCurrentAuthHeader,
      normalizer: (response) => response.results.map((item) => ({
        ...item,
        currency: DEFAULT_CURRENCY,
      })),
    });
  } catch (e) {
    exception(e);
  }
}

export function* doFetchNext(context) {
  yield fork(listingSaga.doFetchNext, {
    fetching,
    getHasNext,
    getNextCursor,
    getFilters,
    doFetch,
  });
}

export function* doFetchPrev() {
  yield fork(listingSaga.doFetchPrev, {
    fetching, // action
    getHasPrev, // selector
    getPrevCursor, // selector
    getFilters, // filters
    doFetch, // geneatr
  });
}

function* doMarkAsPaid({ payload }) {
  const { id } = payload;

  try {
    yield call(api.markAsPaid, id);
    yield put(markedAsPaid(id));
    yield put(
      showNotification(
        I18n.str('invoiceMarkAsPaidSuccess', 'Invoice has been marked as paid.'),
        'success',
      ),
    );
  } catch (e) {
    yield put(
      showNotification(
        I18n.str('invoiceMarkAsPaidSuccess', 'Unable to mark Invoice as paid.'),
        'error',
      ),
    );
    exception(e);
  }
}

function* watcher(context) {
  yield all([
    takeEvery(fetch().type, doFetch),
    takeLatest(fetchNext().type, doFetchNext),
    takeLatest(fetchPrev().type, doFetchPrev),
    takeEvery(markAsPaid().type, doMarkAsPaid),
  ]);
}

export default watcher;
